import React from 'react'

export const Title1 = ({text}) => {
  return (
    <p className='font-bold text-gray-700 dark:text-gray-300 text-lg text-center'>{text}</p>
  )
}
